// extracted by mini-css-extract-plugin
export default {"SavedViewsList":"Sidebar-module__SavedViewsList--MySAE"};